const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay/classic');

const ContextComponent = require('../../../global/components/ContextComponent');
const { Modal, Header, Body } = require('../../../global/views/modal');

const style = require('../styles/ConditionReportModal.scss');
const copy = require('./conditionReportModalCopy.json');
const ConditionReportForm = require('./ConditionReportForm');

class ConditionReportModal extends ContextComponent {
    constructor() {
        super();
        this.onSuccess = this.onSuccess.bind(this);

        this.state = {
            isSent: false,
        };
    }
    componentWillReceiveProps(nextProps) {
        const { isOpened } = this.props;
        if (isOpened && !nextProps.isOpened) {
            this.setState({ isSent: false });
        }
    }
    onSuccess() {
        this.setState({ isSent: true });
    }
    render() {
        const { isSent } = this.state;

        return (
            <Modal {...this.props}>
                <Header>{isSent ? copy.successHeader : copy.header}</Header>
                <Body>
                    {isSent ? (
                        <div
                            className={style.content}
                            dangerouslySetInnerHTML={{ __html: copy.successMessage }}
                        />
                    ) : (
                        <ConditionReportForm {...this.props} onSuccess={this.onSuccess} />
                    )}
                </Body>
            </Modal>
        );
    }
}

ConditionReportModal.propTypes = {
    isOpened: PropTypes.bool.isRequired,
};

module.exports = Relay.createContainer(ConditionReportModal, {
    initialVariables: {
        userId: '',
    },
    fragments: {
        user: ({ userId }) => Relay.QL`
            fragment on User {
                ${ConditionReportForm.getFragment('user', { userId })}
            }
        `,
        item: ({ userId }) => Relay.QL`
            fragment on Item {
                ${ConditionReportForm.getFragment('item', { userId })}
            }
        `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/contact/dealer/components/ConditionReportModal.jsx